import React from "react";
import "./styles.scss";

import {getLanguage} from "../../utils/environment";

const len = getLanguage();

const Index = ({
  data,
  onChange,
  onClick,
  isBorder,
  children,
  onClickViewNews,
  is_header = true
}) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
          className={`news-group-wrapper  ${data.mainType} ${data.mainLayerStyles}`}
      >
        {is_header &&
          <div className={"ngw__header"}>
            <h1 className={`ngwh__title ${data.type}`}>{data.titleName}</h1>
            <div className={"ngwh__border-bottom"}></div>
          </div>
      }

        {children}
        {data.linkName !== "" && (
            <div className={"ngw__link"} onClick={onClickViewNews}>
              {data.linkName}
            </div>
        )}
      </div>
    </>
  );

  return <>{inputElement}</>;
};

export default Index;
